import { Store, Module, ActionContext } from 'vuex';
import ListModule from './list-module';
import ListState from './list-state';
import Agency from '../entities/agency';

import Ajax from '../../lib/ajax';
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations';

interface AgencyState extends ListState<Agency> {
  select: Agency;
}

class AgencyMutations extends ListMutations<Agency> {}

class AgencyModule extends ListModule<AgencyState, any, Agency> {
  state = {
    totalCount: 0,
    currentPage: 1,
    pageSize: 10,
    list: new Array<Agency>(),
    loading: false,
  };
  actions = {
    async getAgency(context: ActionContext<AgencyState, any>, payload: any) {
      context.state.loading = true;
      let reponse = await Ajax.post(
        '/api/services/app/agency/GetAgencyInfo',
        payload.data
      );

      context.state.loading = false;
      let agency = reponse.data.result as Agency;
      context.state.select = agency;
      // context.state.totalCount=page.totalCount;
      // context.state.list=page.items;
    },
  };
  mutations = {
    setCurrentPage(state: AgencyState, page: number) {
      state.currentPage = page;
    },
    setPageSize(state: AgencyState, pagesize: number) {
      state.pageSize = pagesize;
    },
  };
}
const agencyModule = new AgencyModule();
export default agencyModule;
